module.exports = __webpack_public_path__ + "static/media/icon-tree.4f56e8df.svg";